<template>
  <div class="financingFileInfo">
    <table border="0" cellpadding="0" cellspacing="0" class="nyFormTb" style="width: 1020px;">
      <tr class="tr1">
        <!--审核结论-->
        <td class="td1" width="670">{{$t('financingFundDetail.examineConclusion')}}</td>
        <!--审核人-->
        <td class="td2" width="135">{{$t('financingFundDetail.examineMan')}}</td>
        <!--日期-->
        <td class="td3" width="140">{{$t('financingFundDetail.examineTime')}}</td>
      </tr>
      <tr v-for="(item,index) in newData" :key="index"  v-if='listDataParagram.pageSize*(listDataParagram.pageNo-1)<=index && index<listDataParagram.pageSize*listDataParagram.pageNo'>
        <td class="td1">
          <div class="line1Oh" :title="item.auditOpinion">
            {{item.auditOpinion}}
          </div>
        </td>

        <td class="td2">
          <div class="line1Oh">
            {{item.auditName}}
          </div>
        </td>
        <td class="td3">{{item.createTime | dateTimeConvert}}</td>
      </tr>
    </table>
    <el-pagination
      background
      layout="prev, pager, next"
      :current-page.sync="listDataParagram.pageNo"
      :total="newData.length" :page-size.sync="listDataParagram.pageSize"
      @current-change="current_change" class="page-theme" v-if="newData.length>5"
      style="text-align: center;padding-top:17px; padding-bottom: 17px; ">
    </el-pagination>
    <div class="statusEmptyOneLine" v-if="!newData || newData.length===0 ">
      <!--暂无数据-->
      {{$t('frontPage.noData')}}
    </div>
  </div>
</template>
<script>
  export default {
    name: "fundLockAuditRecord", //风控审核记录列表
    props: ["data"],
    data() {
      return {
        value: '',
        listDataParagram: {
          total: 0,
          pageNo: 1,
          pageSize: 5
        }
      };
    },
    computed: {
      newData: function () {
        return this.data
      }
    },
    methods: {
      current_change: function (pageNo) {
        this.listDataParagram.pageNo = pageNo;
      },
    },
    mounted() {
    }
  };
</script>

<style lang="scss" scoped>
</style>
